export enum WssUserClassTypes {
    USER = "user",
}

export enum WssUserEventTypes {
    COMPANY_INVITATION = "company_invitation",
}

export interface WssUserPayload {
    event: WssUserEventTypes;
    companyName: string;
    invitationId: string;
    companyId: string;
}
